module.exports = __webpack_public_path__ + "static/media/ninedot.91b39a14.svg";